import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { injectFacebookDomainVerification } from './lib/domainVerification';
import { initializeMetaPixel } from './lib/metaPixel';
injectFacebookDomainVerification();
initializeMetaPixel();
const rootEl = document.getElementById('root');
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-23" data-mp="2aavvht3az8de" />);
}